import {CircularProgress, Skeleton, Stack, Typography, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useCurrentLocation} from './hooks/useCurrentLocation';
import {CurrentLocationState} from './hooks/useCurrentLocation/types';
import {StyledButton, StyledRoot} from './styles';
import {CurrentLocationProps} from './types';

const {yourCurrentLocation, add} = translations['pt-br'].commons;

export function CurrentLocation({favoriteAddresses}: CurrentLocationProps) {
	const {palette} = useTheme();
	const {state, addressLabel, isAdding, handleAdd} = useCurrentLocation(favoriteAddresses);

	if (state === CurrentLocationState.HIDDEN) return null;

	if (state === CurrentLocationState.LOADING) {
		return <Skeleton variant="rectangular" width="100%" height={56} />;
	}

	return (
		<StyledRoot direction="row" justifyContent="space-between" alignItems="center">
			<Stack direction="row" gap={1} alignItems="center" minWidth={0}>
				<Icon name="location-on-filled" size={24} color={palette.primary.main} />
				<Stack minWidth={0}>
					<Typography variant="caption" color="text.secondary">
						{yourCurrentLocation}
					</Typography>
					<Typography
						variant="subtitle2"
						color="primary"
						fontWeight={600}
						noWrap
						title={addressLabel}>
						{addressLabel}
					</Typography>
				</Stack>
			</Stack>
			<StyledButton
				variant="text"
				onClick={handleAdd}
				disabled={isAdding}
				startIcon={isAdding ? <CircularProgress size={16} /> : undefined}>
				{add}
			</StyledButton>
		</StyledRoot>
	);
}
